import { axiosBasic, axiosBearer } from "../config/axios-common";
import StringToDate from "../helpers/Strings/StringToDate";
import VocationalTraning from "../models/VocationalTraning";



const postInsertOrUpdateVocationalTraning = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/vocationaltraning/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetVocationalTraningFromTasy = async (requestId: string): Promise<VocationalTraning[]> => {

    const response = await axiosBearer.post(`/sam/v1/vocationaltraning/CreateAndGetVocationalTraningFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<VocationalTraning>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let professional = VocationalTraning.NewInstance();

                professional.Id = row.id;
                professional.ExpertiseId = row.expertiseId;
                professional.ExpertiseValue = row.expertiseValue;
                professional.NumberRQE = row.nrRQE;
                professional.TasyCode = row.tasyCode;
                professional.RemoveTasy = row.removeTasy;
                professional.DateAcquisition = StringToDate(row.dateAcquisition);

                return professional;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};

const exportedObject = {
    postInsertOrUpdateVocationalTraning,
    CreateAndGetVocationalTraningFromTasy
};


export default exportedObject